import React, { CSSProperties, FC, ReactNode } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

interface AampeEmptyStateProps {
    imageUrl: string;
    header: string;
    body: ReactNode;
    className?: string;
    bodyContainerStyle?: CSSProperties;
}

const AampeEmptyStateV2: FC<React.PropsWithChildren<AampeEmptyStateProps>> = ({
    header,
    body,
    imageUrl,
    bodyContainerStyle,
    className,
}) => {
    return (
        <Container className={className}>
            <Image alt={'placeholder'} src={imageUrl} />
            <BodyContainer style={bodyContainerStyle}>
                <Header>{header}</Header>

                <Body>{body}</Body>
            </BodyContainer>
        </Container>
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: aampeTheme.colors.primary25,
    border: `1px solid ${aampeTheme.colors.primary50}`,
    borderRadius: '16px',
}));

const BodyContainer = styled.div(() => ({
    textAlign: 'center',
    position: 'absolute',
    bottom: aampeTheme.spacing(5),
}));

const Image = styled.img(() => ({
    width: '100%',
    height: '100%',
    minHeight: '300px',
}));

const Body = styled.div(() => ({
    marginTop: aampeTheme.spacing(2),
    textAlign: 'center',
    maxWidth: '720px',
    lineHeight: '25px',
    fontSize: '16px',
}));

const Header = styled.span(() => ({
    color: aampeTheme.colors.solidA01,
    fontSize: '20px',
    fontWeight: 600,
    textAlign: 'center',
    borderRadius: 16,
}));

export default AampeEmptyStateV2;
